import { GetSupportedTranscriptionStorageType, HostAppName } from '../office-js/HostAppSettings';
import { DocumentStorageOneNote } from '../OneNote/DocumentStorageOneNote';
import { DocumentStorageWord } from '../Word/DocumentStorageWord';
import { DocumentStorageWordXML } from '../Word/DocumentStorageWordXML';
import { HostAppUtil } from '../office-js/HostAppUtil';
import { TranscriptionStorageType } from '../interfaces/IStoredTranscription';

export function CreateDocumentStorage(storageType: TranscriptionStorageType = GetSupportedTranscriptionStorageType()) {
  switch (storageType) {
    case TranscriptionStorageType.DocumentXmlStorage:
      return new DocumentStorageWordXML();
    case TranscriptionStorageType.DocumentStorage: {
      switch (HostAppUtil.GetHostAppName()) {
        case HostAppName.ONENOTE:
          return new DocumentStorageOneNote();
        case HostAppName.WORD:
          return new DocumentStorageWord();
        default:
          throw new Error('Requested App Name (' + HostAppUtil.GetHostAppName() + ') not supported by DocumentStorageFactory.');
      }
    }
    default:
      throw new Error('Requested storageType (' + storageType + ') not supported by DocumentStorageFactory.');
  }
}
